import { useFeedViewPrefs } from '../store/feedViewPrefs'
import { useHiddenPosts } from '../store/hiddenPosts'
import { PinnedFeeds } from './PinnedFeeds'

function SectionHead({ label }: { label: string }) {
  return (
    <div className="px-3 pt-3 pb-1 text-[9px] font-bold uppercase tracking-widest text-ink-500">
      {label}
    </div>
  )
}

function Row({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5 px-3 pb-2">
      {children}
    </div>
  )
}

function Pill({
  active,
  onClick,
  children,
}: {
  active: boolean
  onClick: () => void
  children: React.ReactNode
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-full border px-2 py-0.5 text-[11px] ${
        active
          ? 'border-[color:var(--accent-strong)] bg-white/10 text-white'
          : 'border-white/10 bg-white/5 text-ink-300 hover:bg-white/10'
      }`}
    >
      {children}
    </button>
  )
}

export function FeedViewControlsBody() {
  const viewMode    = useFeedViewPrefs((s) => s.viewMode)
  const setViewMode = useFeedViewPrefs((s) => s.setViewMode)
  const nsfwFilter    = useFeedViewPrefs((s) => s.nsfwFilter)
  const setNsfwFilter = useFeedViewPrefs((s) => s.setNsfwFilter)

  const hiddenCount = useHiddenPosts((s) => s.hiddenUris.length)
  const clearAll    = useHiddenPosts((s) => s.clearAll)

  return (
    <div className="flex h-full flex-col">
      {/* Controls strip */}
      <div className="shrink-0 border-b border-white/5 bg-[#080e1e] pb-2">
        <SectionHead label="view" />
        <Row>
          <Pill active={viewMode === 'gallery'} onClick={() => setViewMode('gallery')}>▦ gallery</Pill>
          <Pill active={viewMode === 'list'}    onClick={() => setViewMode('list')}>☰ feed</Pill>
        </Row>

        <SectionHead label="filter" />
        <Row>
          <Pill active={nsfwFilter === 'all'}  onClick={() => setNsfwFilter('all')}>all</Pill>
          <Pill active={nsfwFilter === 'sfw'}  onClick={() => setNsfwFilter('sfw')}>sfw</Pill>
          <Pill active={nsfwFilter === 'nsfw'} onClick={() => setNsfwFilter('nsfw')}>nsfw</Pill>
        </Row>

        {hiddenCount > 0 && (
          <>
            <SectionHead label="hidden posts" />
            <div className="flex items-center gap-2 px-3 pb-2">
              <span className="text-[11px] text-ink-400">{hiddenCount} hidden</span>
              <button
                type="button"
                onClick={clearAll}
                className="ml-auto text-[10px] text-ink-400 hover:text-rose-200 underline"
              >
                clear all
              </button>
            </div>
          </>
        )}
      </div>

      {/* Feed picker */}
      <div className="min-h-0 flex-1 overflow-hidden">
        <PinnedFeeds />
      </div>
    </div>
  )
}
